// Primary 6 Chinese Data - Part 1
// Based on Primary Chinese P6 Topics.txt

export const p6DataPart1 = {
  title: "小學六年級中文學習",
  description: "專為小學六年級學生設計的中文學習內容，進一步提升語文能力和寫作技巧",
  objectives: "提升語文運用能力，培養寫作思維，掌握更複雜的語法結構",
  focus: "重點學習文言字詞、同音字、段義理解等進階語法，以及更豐富的文體閱讀理解",
  
  readingTypes: [
    "新閱稿", "借事說理", "演講辭", "描寫景物", "記人", "記事",
    "借事抒情", "啟事", "說物"
  ],
  
  languageUsage: [
    {
      title: "文言字詞",
      description: "學習文言字詞的用法，掌握文言文的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的文言字詞：『之』在文言文中表示（ ）",
          answer: "的",
          explanation: "『之』在文言文中表示『的』的意思。"
        },
        {
          question: "選擇正確的文言字詞：『而』在文言文中表示（ ）",
          answer: "而且",
          explanation: "『而』在文言文中表示『而且』的意思。"
        },
        {
          question: "選擇正確的文言字詞：『乃』在文言文中表示（ ）",
          answer: "於是",
          explanation: "『乃』在文言文中表示『於是』的意思。"
        },
        {
          question: "選擇正確的文言字詞：『亦』在文言文中表示（ ）",
          answer: "也",
          explanation: "『亦』在文言文中表示『也』的意思。"
        },
        {
          question: "選擇正確的文言字詞：『其』在文言文中表示（ ）",
          answer: "他的",
          explanation: "『其』在文言文中表示『他的』的意思。"
        },
        {
          question: "選擇正確的文言字詞：『於』在文言文中表示（ ）",
          answer: "在",
          explanation: "『於』在文言文中表示『在』的意思。"
        },
        {
          question: "選擇正確的文言字詞：『以』在文言文中表示（ ）",
          answer: "用",
          explanation: "『以』在文言文中表示『用』的意思。"
        },
        {
          question: "選擇正確的文言字詞：『為』在文言文中表示（ ）",
          answer: "是",
          explanation: "『為』在文言文中表示『是』的意思。"
        },
        {
          question: "選擇正確的文言字詞：『者』在文言文中表示（ ）",
          answer: "的人",
          explanation: "『者』在文言文中表示『的人』的意思。"
        },
        {
          question: "選擇正確的文言字詞：『也』在文言文中表示（ ）",
          answer: "句末語氣詞",
          explanation: "『也』在文言文中是句末語氣詞。"
        }
      ]
    },
    {
      title: "同音字",
      description: "學習同音字的區別，掌握同音字的不同用法",
      sampleQuestions: [
        {
          question: "選擇正確的同音字：我喜歡（ ）書",
          answer: "讀",
          explanation: "『讀』是讀書的意思，注意與『毒』的區別。"
        },
        {
          question: "選擇正確的同音字：這（ ）花很漂亮",
          answer: "朵",
          explanation: "『朵』是量詞，注意與『躲』的區別。"
        },
        {
          question: "選擇正確的同音字：我（ ）家吃飯",
          answer: "回",
          explanation: "『回』是回家的意思，注意與『會』的區別。"
        },
        {
          question: "選擇正確的同音字：這（ ）書很有趣",
          answer: "本",
          explanation: "『本』是量詞，注意與『笨』的區別。"
        },
        {
          question: "選擇正確的同音字：我（ ）媽媽去買菜",
          answer: "跟",
          explanation: "『跟』是跟隨的意思，注意與『根』的區別。"
        },
        {
          question: "選擇正確的同音字：這（ ）魚很新鮮",
          answer: "條",
          explanation: "『條』是量詞，注意與『調』的區別。"
        },
        {
          question: "選擇正確的同音字：我（ ）弟弟玩",
          answer: "和",
          explanation: "『和』是連詞，注意與『合』的區別。"
        },
        {
          question: "選擇正確的同音字：這（ ）貓很可愛",
          answer: "隻",
          explanation: "『隻』是量詞，注意與『知』的區別。"
        },
        {
          question: "選擇正確的同音字：我（ ）老師學習",
          answer: "向",
          explanation: "『向』是介詞，注意與『像』的區別。"
        },
        {
          question: "選擇正確的同音字：這（ ）車很新",
          answer: "輛",
          explanation: "『輛』是量詞，注意與『兩』的區別。"
        }
      ]
    },
    {
      title: "段義理解",
      description: "學習段落意思的理解，掌握段落的主旨和中心思想",
      sampleQuestions: [
        {
          question: "這段話的主要意思是（ ）：春天來了，花兒開了，鳥兒唱歌了。",
          answer: "春天很美麗",
          explanation: "這段話描述了春天的美麗景象。"
        },
        {
          question: "這段話的主要意思是（ ）：小明很聰明，他學習很認真，成績很好。",
          answer: "小明學習很好",
          explanation: "這段話說明了小明的學習情況。"
        },
        {
          question: "這段話的主要意思是（ ）：這本書很有趣，內容很豐富，我很喜歡。",
          answer: "這本書很好",
          explanation: "這段話表達了對這本書的喜愛。"
        },
        {
          question: "這段話的主要意思是（ ）：公園裡有很多人，有的在散步，有的在跑步。",
          answer: "公園很熱鬧",
          explanation: "這段話描述了公園的熱鬧景象。"
        },
        {
          question: "這段話的主要意思是（ ）：媽媽很辛苦，每天要做飯，要洗衣服。",
          answer: "媽媽很辛苦",
          explanation: "這段話說明了媽媽的辛苦。"
        },
        {
          question: "這段話的主要意思是（ ）：這隻貓很可愛，毛很軟，眼睛很亮。",
          answer: "這隻貓很可愛",
          explanation: "這段話描述了貓的可愛特徵。"
        },
        {
          question: "這段話的主要意思是（ ）：這個蘋果很甜，很脆，很好吃。",
          answer: "這個蘋果很好吃",
          explanation: "這段話表達了對蘋果的喜愛。"
        },
        {
          question: "這段話的主要意思是（ ）：這個房間很大，很乾淨，很舒服。",
          answer: "這個房間很好",
          explanation: "這段話描述了房間的優點。"
        },
        {
          question: "這段話的主要意思是（ ）：這個故事很有趣，情節很精彩，我很喜歡。",
          answer: "這個故事很好",
          explanation: "這段話表達了對故事的喜愛。"
        },
        {
          question: "這段話的主要意思是（ ）：這個遊戲很好玩，規則很簡單，我很喜歡。",
          answer: "這個遊戲很好",
          explanation: "這段話表達了對遊戲的喜愛。"
        }
      ]
    },
    {
      title: "詞語的搭配",
      description: "學習詞語的搭配，掌握詞語的正確用法",
      sampleQuestions: [
        {
          question: "選擇正確的搭配：『認真』可以搭配（ ）",
          answer: "學習",
          explanation: "『認真學習』是正確的搭配。"
        },
        {
          question: "選擇正確的搭配：『努力』可以搭配（ ）",
          answer: "工作",
          explanation: "『努力工作』是正確的搭配。"
        },
        {
          question: "選擇正確的搭配：『仔細』可以搭配（ ）",
          answer: "觀察",
          explanation: "『仔細觀察』是正確的搭配。"
        },
        {
          question: "選擇正確的搭配：『專心』可以搭配（ ）",
          answer: "讀書",
          explanation: "『專心讀書』是正確的搭配。"
        },
        {
          question: "選擇正確的搭配：『耐心』可以搭配（ ）",
          answer: "等待",
          explanation: "『耐心等待』是正確的搭配。"
        },
        {
          question: "選擇正確的搭配：『細心』可以搭配（ ）",
          answer: "照顧",
          explanation: "『細心照顧』是正確的搭配。"
        },
        {
          question: "選擇正確的搭配：『用心』可以搭配（ ）",
          answer: "做事",
          explanation: "『用心做事』是正確的搭配。"
        },
        {
          question: "選擇正確的搭配：『小心』可以搭配（ ）",
          answer: "走路",
          explanation: "『小心走路』是正確的搭配。"
        },
        {
          question: "選擇正確的搭配：『開心』可以搭配（ ）",
          answer: "玩耍",
          explanation: "『開心玩耍』是正確的搭配。"
        },
        {
          question: "選擇正確的搭配：『快樂』可以搭配（ ）",
          answer: "生活",
          explanation: "『快樂生活』是正確的搭配。"
        }
      ]
    },
    {
      title: "遞進複句的造句策略",
      description: "學習遞進複句的造句策略，掌握遞進句的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的遞進詞：我不但喜歡讀書，（ ）我也喜歡畫畫。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        },
        {
          question: "選擇正確的遞進詞：他不但聰明，（ ）他還很勤奮。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        },
        {
          question: "選擇正確的遞進詞：她不但可愛，（ ）她還很善良。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        },
        {
          question: "選擇正確的遞進詞：這本書不但有趣，（ ）它還很有用。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        },
        {
          question: "選擇正確的遞進詞：這個蘋果不但甜，（ ）它還很脆。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        },
        {
          question: "選擇正確的遞進詞：我不但會唱歌，（ ）我還會跳舞。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        },
        {
          question: "選擇正確的遞進詞：他不但會畫畫，（ ）他還會寫字。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        },
        {
          question: "選擇正確的遞進詞：她不但會游泳，（ ）她還會跑步。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        },
        {
          question: "選擇正確的遞進詞：我不但會做飯，（ ）我還會洗衣服。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        },
        {
          question: "選擇正確的遞進詞：他不但會讀書，（ ）他還會寫作。",
          answer: "而且",
          explanation: "『而且』是遞進複句的連接詞。"
        }
      ]
    }
  ]
};

// Primary 6 Chinese Data - Part 2
export const p6DataPart2 = {
  languageUsage: [
    {
      title: "擬人",
      description: "學習擬人的用法，掌握擬人的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的擬人：花兒在（ ）",
          answer: "微笑",
          explanation: "擬人手法，把花兒當作人來描寫。"
        },
        {
          question: "選擇正確的擬人：小鳥在（ ）",
          answer: "唱歌",
          explanation: "擬人手法，把小鳥當作人來描寫。"
        },
        {
          question: "選擇正確的擬人：風兒在（ ）",
          answer: "跳舞",
          explanation: "擬人手法，把風兒當作人來描寫。"
        },
        {
          question: "選擇正確的擬人：太陽在（ ）",
          answer: "微笑",
          explanation: "擬人手法，把太陽當作人來描寫。"
        },
        {
          question: "選擇正確的擬人：月亮在（ ）",
          answer: "微笑",
          explanation: "擬人手法，把月亮當作人來描寫。"
        },
        {
          question: "選擇正確的擬人：星星在（ ）",
          answer: "眨眼",
          explanation: "擬人手法，把星星當作人來描寫。"
        },
        {
          question: "選擇正確的擬人：小草在（ ）",
          answer: "點頭",
          explanation: "擬人手法，把小草當作人來描寫。"
        },
        {
          question: "選擇正確的擬人：大樹在（ ）",
          answer: "招手",
          explanation: "擬人手法，把大樹當作人來描寫。"
        },
        {
          question: "選擇正確的擬人：小溪在（ ）",
          answer: "唱歌",
          explanation: "擬人手法，把小溪當作人來描寫。"
        },
        {
          question: "選擇正確的擬人：海浪在（ ）",
          answer: "跳舞",
          explanation: "擬人手法，把海浪當作人來描寫。"
        }
      ]
    },
    {
      title: "古詩",
      description: "學習古詩的理解，掌握古詩的意境和表達方法",
      sampleQuestions: [
        {
          question: "『床前明月光，疑是地上霜』這首詩描寫的是（ ）",
          answer: "月光",
          explanation: "這首詩描寫了明亮的月光。"
        },
        {
          question: "『春眠不覺曉，處處聞啼鳥』這首詩描寫的是（ ）",
          answer: "春天",
          explanation: "這首詩描寫了春天的景象。"
        },
        {
          question: "『鋤禾日當午，汗滴禾下土』這首詩描寫的是（ ）",
          answer: "農民",
          explanation: "這首詩描寫了農民勞動的辛苦。"
        },
        {
          question: "『白日依山盡，黃河入海流』這首詩描寫的是（ ）",
          answer: "自然",
          explanation: "這首詩描寫了自然的壯麗景象。"
        },
        {
          question: "『遠看山有色，近聽水無聲』這首詩描寫的是（ ）",
          answer: "山水",
          explanation: "這首詩描寫了山水的美麗。"
        },
        {
          question: "『千山鳥飛絕，萬徑人蹤滅』這首詩描寫的是（ ）",
          answer: "寂靜",
          explanation: "這首詩描寫了寂靜的環境。"
        },
        {
          question: "『孤舟蓑笠翁，獨釣寒江雪』這首詩描寫的是（ ）",
          answer: "漁夫",
          explanation: "這首詩描寫了漁夫釣魚的情景。"
        },
        {
          question: "『小荷才露尖尖角，早有蜻蜓立上頭』這首詩描寫的是（ ）",
          answer: "荷花",
          explanation: "這首詩描寫了荷花的嬌嫩。"
        },
        {
          question: "『停車坐愛楓林晚，霜葉紅於二月花』這首詩描寫的是（ ）",
          answer: "楓葉",
          explanation: "這首詩描寫了楓葉的美麗。"
        },
        {
          question: "『兩個黃鸝鳴翠柳，一行白鷺上青天』這首詩描寫的是（ ）",
          answer: "鳥類",
          explanation: "這首詩描寫了鳥類的美麗。"
        }
      ]
    },
    {
      title: "形近字",
      description: "學習形近字的區別，掌握漢字的字形特點",
      sampleQuestions: [
        {
          question: "選擇正確的字：我喜歡（ ）書",
          answer: "讀",
          explanation: "『讀』是讀書的意思，注意與『賣』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）花很漂亮",
          answer: "朵",
          explanation: "『朵』是量詞，注意與『躲』的區別。"
        },
        {
          question: "選擇正確的字：我（ ）家吃飯",
          answer: "回",
          explanation: "『回』是回家的意思，注意與『四』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）書很有趣",
          answer: "本",
          explanation: "『本』是量詞，注意與『木』的區別。"
        },
        {
          question: "選擇正確的字：我（ ）媽媽去買菜",
          answer: "跟",
          explanation: "『跟』是跟隨的意思，注意與『根』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）魚很新鮮",
          answer: "條",
          explanation: "『條』是量詞，注意與『修』的區別。"
        },
        {
          question: "選擇正確的字：我（ ）弟弟玩",
          answer: "和",
          explanation: "『和』是連詞，注意與『合』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）貓很可愛",
          answer: "隻",
          explanation: "『隻』是量詞，注意與『知』的區別。"
        },
        {
          question: "選擇正確的字：我（ ）老師學習",
          answer: "向",
          explanation: "『向』是介詞，注意與『像』的區別。"
        },
        {
          question: "選擇正確的字：這（ ）車很新",
          answer: "輛",
          explanation: "『輛』是量詞，注意與『兩』的區別。"
        }
      ]
    },
    {
      title: "動量詞",
      description: "學習動量詞的用法，掌握動量詞的正確搭配",
      sampleQuestions: [
        {
          question: "選擇正確的動量詞：我（ ）讀書",
          answer: "讀一遍",
          explanation: "『讀一遍』是動量詞搭配。"
        },
        {
          question: "選擇正確的動量詞：他（ ）唱歌",
          answer: "唱一首",
          explanation: "『唱一首』是動量詞搭配。"
        },
        {
          question: "選擇正確的動量詞：她（ ）跳舞",
          answer: "跳一支",
          explanation: "『跳一支』是動量詞搭配。"
        },
        {
          question: "選擇正確的動量詞：我（ ）畫畫",
          answer: "畫一幅",
          explanation: "『畫一幅』是動量詞搭配。"
        },
        {
          question: "選擇正確的動量詞：他（ ）寫字",
          answer: "寫一行",
          explanation: "『寫一行』是動量詞搭配。"
        },
        {
          question: "選擇正確的動量詞：她（ ）游泳",
          answer: "游一圈",
          explanation: "『游一圈』是動量詞搭配。"
        },
        {
          question: "選擇正確的動量詞：我（ ）跑步",
          answer: "跑一圈",
          explanation: "『跑一圈』是動量詞搭配。"
        },
        {
          question: "選擇正確的動量詞：他（ ）騎車",
          answer: "騎一圈",
          explanation: "『騎一圈』是動量詞搭配。"
        },
        {
          question: "選擇正確的動量詞：她（ ）彈琴",
          answer: "彈一曲",
          explanation: "『彈一曲』是動量詞搭配。"
        },
        {
          question: "選擇正確的動量詞：我（ ）做飯",
          answer: "做一頓",
          explanation: "『做一頓』是動量詞搭配。"
        }
      ]
    },
    {
      title: "對比",
      description: "學習對比的用法，掌握對比的表達方法",
      sampleQuestions: [
        {
          question: "選擇正確的對比：小明很聰明，（ ）小華很勤奮。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        },
        {
          question: "選擇正確的對比：我喜歡紅色，（ ）他喜歡藍色。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        },
        {
          question: "選擇正確的對比：這本書很有趣，（ ）那本書很無聊。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        },
        {
          question: "選擇正確的對比：這個蘋果很甜，（ ）那個蘋果很酸。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        },
        {
          question: "選擇正確的對比：小華很可愛，（ ）小美很漂亮。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        },
        {
          question: "選擇正確的對比：我會唱歌，（ ）他會跳舞。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        },
        {
          question: "選擇正確的對比：她會畫畫，（ ）我會寫字。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        },
        {
          question: "選擇正確的對比：我會游泳，（ ）他會跑步。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        },
        {
          question: "選擇正確的對比：我會做飯，（ ）他會洗衣服。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        },
        {
          question: "選擇正確的對比：我會讀書，（ ）他會寫作。",
          answer: "而",
          explanation: "『而』用來表示對比。"
        }
      ]
    }
  ]
}; 